import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import QuestionTitle from "./QuestionTitle";
import ExplanationSection from "./ExplanationSection";
import QuestionOptionList from "./QuestionOptionList";
import QuizLoader from "./../Loader/QuizLoader";
import { captureAnswer } from "examsbook-react-sdk/actions";
import QuestionDirection from "./QuestionDirection";
import useStyles from "examsbook-react-sdk/custom-hooks/useStyles";
import LongMenu from "../../longMenu";
import { formatQuestion, TimeUtils } from "examsbook-react-sdk/common";

/**
 * Single question box.
 * @param props
 * @returns {*}
 * @constructor
 */

function QuestionBox(props) {
    const dispatch = useDispatch();
    const { activeQuestionIndex, isLoading, mode, number, viewMode, total, drawerToggle } = props;
    const selectedQuestion = useSelector((state) => state.selectedQuestion);
    const language = useSelector((state) => state.user.language);
    const classes = useStyles(styles)();

    function onRadioChange(e, optionIndex, activeQuesIndex, quesType) {
        if (viewMode) {
            return;
        }
        let givenAns = selectedQuestion.givenAnswer || [];
        let clearRadio = false;
        if (quesType !== 'MultiChoice') {
            if (givenAns.indexOf(e.target.value) > -1) {
                clearRadio = true;
            }
            givenAns = [];
        }

        if (!clearRadio) {
            if (e.target.checked) {
                givenAns.push(e.target.value);
            } else {
                givenAns = givenAns ? givenAns.filter((item) => {
                    return item !== e.target.value;
                }) : [];
            }
        }
        dispatch(captureAnswer(givenAns));
    }

    function changeTimeFormat(spentTime) {
        return TimeUtils.changeTimeFormat(spentTime);
    }

    const {
        type,
        explanation,
        localesExplanation,
        localesTitle,
        title,
        mark,
        penalty,
        givenAnswer,
        timeSpent,
        direction,
        options,
        markObtain,
        className,
        localesDirection
    } = formatQuestion(selectedQuestion, viewMode, language);
    const quizDirectionClass = direction && direction.type === 'LONG_TEXT' ? classes.quizDirectionBlock : '';

    return (
        <>
            <div className={drawerToggle ? classes.questionBoxExpand : classes.questionBox}>
                <div className={classes.quizComprehension}>
                    {direction && direction.name && direction.type === 'LONG_TEXT' ?
                        <QuestionDirection direction={direction} localesDirection={localesDirection}/> : null
                    }
                    <div className={classes.box + ' ' + quizDirectionClass}>
                        {
                            !isLoading ? <React.Fragment>
                                <QuestionTitle mark={markObtain ? markObtain : '0'} questionMark={mark}
                                               penalty={penalty}
                                               classNameInView={className ? className : classes.marksBadges}
                                               timeSpent={timeSpent ? changeTimeFormat(timeSpent) : '00:00'}
                                               viewMode={viewMode} direction={direction} title={title} total={total}
                                               number={number} localesTitle={localesTitle}
                                               localesDirection={localesDirection}/>

                                <QuestionOptionList options={options} type={type} showAnswer={viewMode}
                                                    viewMode={viewMode} givenAnswer={givenAnswer} mode={mode}
                                                    onRadioChange={onRadioChange}
                                                    activeQuestionIndex={activeQuestionIndex}/>


                                <div className={classes.showAnswer}>
                                    <LongMenu question={selectedQuestion}/>
                                </div>
                                <ExplanationSection explanation={explanation} localesExplanation={localesExplanation} viewMode={viewMode} mode={mode}
                                                    showAnswer={viewMode}/>
                            </React.Fragment> : <QuizLoader/>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

const styles = theme => ({
    questionBox: {
        position: 'absolute',
        top: 70,
        left: 170,
        right: 20,
        maxHeight: 'calc(100vh - 150px)',
        transition: '0.3s all linear',
        overflow: 'hidden',
        '@media (max-width:767px)': {
            left: 0,
            right: 0,
            top: 55,
            maxHeight: 'calc(100vh - 0px)',

        },
        '@media (min-width: 768px) and (max-width:1024px)': {
            left: 90
        }
    },
    questionBoxExpand: {
        position: 'absolute',
        top: 85,
        left: -110,
        right: 20,
        maxHeight: 'calc(100vh - 150px)',
        transition: '0.3s all linear',
        overflow: 'hidden',
        '@media (max-width:1100px) and (min-width:768px)': {
            left: 90,
        },
        '@media (max-width:767px)': {
            left: 0,
            right: 0,
            top: 55,
            maxHeight: 'calc(100vh - 0px)'
        }
    },
    quizComprehension: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 'calc(100vh - 145px)',
        '@media (max-width:767px)': {
            height: '100vh'
        }
    },
    quizDirectionBlock: {
        maxHeight: 'calc(100vh - 145px)',
        overflow: 'auto'
    },
    box: {
        overflow: 'auto',
        maxHeight: 'calc(100vh - 145px)',
        float: 'left',
        width: 'calc(100% - 20px)',
        boxShadow: '0 0 2px #ccc',
        margin: '20px 8px 10px',
        backgroundColor: '#fff',
        position: 'relative',
        textAlign: 'left',
        padding: '0 15px',
        '&::-webkit-scrollbar': {
            width: 6,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#d3d5d3'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#eeecec'
        },
        '@media (max-width:767px)': {
            width: 'calc(100% - 0px)',
            margin: 0,
            maxHeight: '100vh',
            padding: '0 11px',
            paddingBottom: 60
        }
    },
    showAnswerIcon: {
        position: 'absolute',
        top: -3,
        left: 0,
        color: '#9c9c9c',
        cursor: 'pointer',
        fontSize: 24,
        '@media (max-width:767px)': {
            top: 12,
            left: '50px',
            fontSize: 26,
            zIndex: 999,
            marginLeft: 10
        },
        '& .fa-bookmark-o': {
            color: '#008e76'
        },
        '& .fa-bookmark': {
            color: '#008e76'
        }
    },
    showAnswer: {
        position: 'absolute',
        top: 0,
        right: 0,
        fontSize: 20,
        '@media (max-width:767px)': {
            top: 3,
            right: 0
        }
    },
    reportError: {
        color: '#000',
        '&:hover': {
            color: '#000',
        }
    },
    minHeight: {
        maxHeight: 'inherit',
        overflow: 'hidden'
    },
    marksBadges: {
        backgroundColor: '#ffc65820',
        color: '#ffc658',
        border: '1px solid #ffc658',
        borderRadius: 2,
        padding: '2px 6px',
        fontSize: 13,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        marginRight: 0,
        display: 'flex',
    }
});

export default QuestionBox;
